import React, {useMemo} from 'react'

import {useMapComponents} from '../../../lib'
import type {Feature, MapClustererProps} from '../../../model'

export default function MapClusterer<F extends Feature = Feature>({
  gridSize = 64,
  ...props
}: MapClustererProps<F>): React.ReactElement<MapClustererProps> | null {
  const mapContext = useMapComponents()

  const {clusterByGrid, YMapClusterer} = mapContext || {}
  const gridSizedMethod = useMemo(() => clusterByGrid?.({gridSize}), [clusterByGrid, gridSize])

  if (!mapContext) {
    return null
  }

  // @ts-expect-error у наших компонентов нет обертки <YMapEntity />
  return <YMapClusterer method={gridSizedMethod} {...props} />
}
